import {
  MdoBasketUploadCheckResponse,
  UploadBasket,
} from '@epicuro-next/data/baskets';
import { createAction, props } from '@ngrx/store';
import { ValidationResult } from 'graphql-api/baskets-api-interfaces';

export const uploadSDOBasket = createAction(
  '[Basket] Upload SDO Basket',
  props<{
    uploadBasket: Omit<UploadBasket, 'addressIds'>;
    addToExistingBasket: boolean;
  }>(),
);

export const uploadSDOBasketSuccess = createAction(
  '[Basket] Upload SDO Basket Success',
  props<{ basketId: string; validationResults: ValidationResult[] }>(),
);
export const uploadSDOBasketFailure = createAction(
  '[Basket] Upload SDO Basket Failure',
  props<{ error: string }>(),
);

export const resetUploadBasketState = createAction(
  '[Basket] Reset Upload Basket',
);

export const checkMDOBasket = createAction(
  '[Basket] Check MDO Basket',
  props<{ file: File }>(),
);

export const checkMDOBasketSuccess = createAction(
  '[Basket] Check MDO Basket Success',
  props<{ mdoUploadCheckResult: MdoBasketUploadCheckResponse }>(),
);
export const checkMDOBasketFailure = createAction(
  '[Basket] Check MDO Basket Failure',
  props<{ error: string }>(),
);

export const importMDOBasket = createAction(
  '[Basket] Import MDO Basket',
  props<{ skipErrors: boolean; addToExistingBasket: boolean }>(),
);

export const importMDOBasketSuccess = createAction(
  '[Basket] Import MDO Basket Success',
  props<{ basketId: string }>(),
);
export const importMDOBasketFailure = createAction(
  '[Basket] Import MDO Basket Failure',
  props<{ error: string }>(),
);
